import Refluxr from '../../lib/refluxr';
import { OnlineApi } from '../services';
import container from '../core/container';

// Recognized business outcomes are displayed beside the relevant Target.
// Unknown failures still reach OpsPerfect's global error/feedback handlers.
const handledCodes = {
   REGISTER_DATA_TARGET: ['AlreadyExists', 'InvalidSpreadsheetId', 'InvalidTargetName', 'UnsupportedTargetType'],
   DELETE_DATA_TARGET: ['NotFound', 'InvalidTargetId', 'InvalidTransition'],
   RESTORE_DATA_TARGET: ['NotFound', 'InvalidTargetId', 'InvalidTransition'],
   UPDATE_DATA_TARGET: ['NotFound', 'InvalidTargetId', 'InvalidTransition', 'TargetArchived', 'AlreadyExists', 'InvalidTargetName', 'InvalidSpreadsheetId', 'NoChanges'],
   VERIFY_DATA_TARGET: ['UnsupportedTargetType', 'InvalidTargetId', 'TargetArchived', 'NotFound',
      'GoogleConfigurationInvalid', 'GoogleConfigurationMissing', 'AccessDenied',
      'NotFoundOrInaccessible', 'GoogleAuthenticationFailed', 'ProviderError']
};

export const isHandledTargetOutcome = (response) => {
   const payload = response && response.data && (response.data.content || response.data);
   const codes = response && handledCodes[response.messageType];
   const isHandledStatus = response && ((response.status >= 400 && response.status < 500) || response.status === 503);
   return !!(isHandledStatus && codes && payload && codes.includes(payload.code));
};

export const isExpectedDuplicate = (response) => {
   const payload = response && response.data && (response.data.content || response.data);
   return !!(response && response.status === 409 && response.messageType === 'REGISTER_DATA_TARGET' && payload && payload.code === 'AlreadyExists');
};

const globalHandler = (args) => {
   if (!isHandledTargetOutcome(args)) {
      const handle = container.getGlobalHandler();
      if (handle) handle(args);
   }
   args.action.failed(args);
};

// Refluxr invokes the feedback handler separately from the global handler.
const standardFeedbackHandler = container.getFeedbackHandler();
export const feedbackHandler = (args) => {
   if (args.end && isHandledTargetOutcome(args.end.response)) return;
   if (standardFeedbackHandler) standardFeedbackHandler(args);
};

const DataTargetActions = Refluxr.createActions([
   'clearSelectedTarget',
   'setTargetFilter',
   'viewDeletedTarget',
   { fetchTargets: OnlineApi.query, prepare: () => ({ messageType: 'FETCH_DATA_TARGETS' }) },
   { registerTarget: OnlineApi.send, prepare: ({ name, resourceId }) => ({ messageType: 'REGISTER_DATA_TARGET', name: name.trim(), targetType: 'GOOGLE_SHEETS', resourceId: resourceId.trim() }) },
   { getTarget: OnlineApi.query, prepare: ({ id }) => ({ messageType: 'GET_DATA_TARGET', id }) },
   { deleteTarget: OnlineApi.send, prepare: ({ id }) => ({ messageType: 'DELETE_DATA_TARGET', id }) },
   { restoreTarget: OnlineApi.send, prepare: ({ id }) => ({ messageType: 'RESTORE_DATA_TARGET', id }) },
   { updateTarget: OnlineApi.send, prepare: ({ id, name, resourceId }) => ({ messageType: 'UPDATE_DATA_TARGET', id, ...(name !== undefined ? { name } : {}), ...(resourceId !== undefined ? { resourceId } : {}) }) },
   { verifyTarget: OnlineApi.send, prepare: ({ id }) => ({ messageType: 'VERIFY_DATA_TARGET', id }) }
], globalHandler, feedbackHandler);

export default DataTargetActions;
